import { render, staticRenderFns } from "./PI-Single-Page.vue?vue&type=template&id=e1cc54a8&"
import script from "./PI-Single-Page.vue?vue&type=script&lang=js&"
export * from "./PI-Single-Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports